/** Matches a plain tab or view name such as `training`, `sent` or `b2b-responses`. */
const PLAIN_NAME = /^[a-z][a-z-]*$/;

/**
 * [MCV-1866] The page a support request came from, for the support email.
 *
 * Origin and path, plus the two things that pick what the user actually sees on some pages: a
 * plain tab-name hash (`/vault/academics#training`) and the `view` param
 * (B2B Opportunities' `view=sent`), each only when it is a plain lowercase name. Everything
 * else in the query string is left out: it can carry invitation codes and other one-time values.
 */
export const supportPageUrl = ({
  origin,
  pathname,
  search,
  hash,
}: Pick<Location, 'origin' | 'pathname' | 'search' | 'hash'>): string => {
  const view = new URLSearchParams(search).get('view');
  const query = view && PLAIN_NAME.test(view) ? `?view=${view}` : '';
  const tab = hash.startsWith('#') ? hash.slice(1) : '';
  const fragment = PLAIN_NAME.test(tab) ? `#${tab}` : '';
  return `${origin}${pathname}${query}${fragment}`;
};
